import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiAuthMe, apiAuthLogout, setEffectiveSessionId, clearEffectiveSessionId, getAnonSessionId } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await apiAuthMe();
      setUser(r.user);
      setEffectiveSessionId(r.session_id);
    } catch {
      setUser(null);
      clearEffectiveSessionId();
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: if returning from OAuth callback, skip /me check —
    // AuthCallback will exchange the session_id and establish the session first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `${process.env.REACT_APP_BACKEND_URL}/api/auth/google/login`;
  };

  const logout = async () => {
    try { await apiAuthLogout(); } catch {}
    clearEffectiveSessionId();
    setUser(null);
    // regenerate a fresh anonymous session_id after logout
    localStorage.removeItem("resell_ai_sid");
    getAnonSessionId();
  };

  const finalizeLogin = (data) => {
    setUser(data.user);
    setEffectiveSessionId(data.session_id);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, checkAuth, finalizeLogin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
